"use client";

import Link from "next/link";
import styles from "./our-services.module.scss";

import MapIcon from "@mui/icons-material/Map";
import BarChartIcon from "@mui/icons-material/BarChart";
import InsertChartIcon from "@mui/icons-material/InsertChart";
import DataUsageIcon from "@mui/icons-material/DataUsage";
import ContactMailIcon from "@mui/icons-material/ContactMail";

const CONTACT_URL = "/contact-us";
const CARDS = [
  {
    icon: <MapIcon sx={{ fontSize: 48 }} />,
    title: "Remote sensing-driven, AI-generated maps : anytime, anywhere.",
    desc: "We leverage Earth observation data from 2017 to the present, enabling temporal trend analysis and forward-looking forecasts. Our models generalise across different geographies and are deployed on a computational platform built for quick and cost-effective inference. Every output is rigorously validated through manual expert review before it reaches you.",
    link: "/services?tab=maps",
    linkLabel: "↗ Learn more",
  },
  {
    icon: <BarChartIcon sx={{ fontSize: 48 }} />,
    title: "Hydrology analysis.",
    desc: "Our Specific Yield on-demand service enables you to understand how your bog responds to rain events, in accordance with Peatland Finance Ireland's standard for Ireland.",
    link: "/services?tab=specific-yield",
    linkLabel: "↗ Learn more",
  },
  {
    icon: <InsertChartIcon sx={{ fontSize: 48 }} />,
    title: "GHG Emission estimation.",
    desc: "Our GHG emission estimation on-demand service enables you to estimate GHG emissions on raised bogs, in accordance with Peatland Finance Ireland's standard for Ireland.",
    link: "/services?tab=pfi-scorecard",
    linkLabel: "↗ Learn more",
  },
  {
    icon: <DataUsageIcon sx={{ fontSize: 48 }} />,
    title: "On-demand computation.",
    desc: "If you have in-house expertise and simply need our maps, our on-demand inference is one click away. Access our models directly, on your terms, without any overhead.",
    link: "/peatsense",
  },
  {
    icon: <ContactMailIcon sx={{ fontSize: 48 }} />,
    title: "Bespoke condition mapping.",
    desc: "Don't see what you need? We build it with you. Through continuous engagement, we develop new capabilities tailored to your specific needs — whether that means a new condition indicator, a new geography, or an entirely new analytical approach.",
    link: CONTACT_URL,
    linkLabel: "↗ Request a service",
  },
];

export default function OurServices() {
  return (
    <section className={styles.section}>
      <div>
        <div className={styles.label}>Service categories</div>
        <h2 className={styles.title}>What we offer</h2>
        <p className={styles.intro}>
          AI2Peat delivers on-demand services built on remote sensing and
          AI : giving landowners, agencies, and researchers reliable peatland
          intelligence at any scale, anywhere in Ireland.
        </p>
      </div>

      <div className={styles.cards}>
        {CARDS.map((card) => (
          <div key={card.title} className={styles.card}>
            <div className={styles.cardHeader}>
              <div className={styles.cardIcon}>{card.icon}</div>
              <h3 className={styles.cardTitle}>{card.title}</h3>
            </div>
            <div className={styles.cardBody}>
              <p className={styles.cardDesc}>{card.desc}</p>
              <Link href={card.link} className={styles.cardLink}>
                {card.linkLabel}
              </Link>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
